import client from "./axiosConfig";

export const getUser = () => {
  const config = {
    url: "/users/",
    method: "GET",
  };
  const response = client(config);
  return response;
};

export const getAllUsers = (params) => {
  const config = {
    url: "/users/all/",
    method: "GET",
    params,
  };
  const response = client(config);
  return response;
};

export const updateLoggedInUser = (data) => {
  const config = {
    url: "/users/",
    method: "PATCH",
    data,
  };
  const response = client(config);
  return response;
};

export const approveUserById = (data) => {
  const config = {
    url: "/users/review/",
    method: "PATCH",
    data
  };
  const response = client(config);
  return response;
}

export const bulkUpdateUsers = (data) => {
  const config = {
    url: "/users/bulk-review/",
    method: "PATCH",
    data,
  };
  const response = client(config);
  return response;
};